import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-account-corporate-review',
  templateUrl: './new-account-corporate-review.component.html',
  styleUrls: ['./new-account-corporate-review.component.scss']
})
export class NewAccountCorporateReviewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
